import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company */}
          <div>
            <h3 className="font-heading font-extrabold text-2xl uppercase tracking-tight mb-4">
              R.K. Traders
            </h3>
            <p className="font-mono text-[10px] tracking-[0.3em] text-neutral-500 uppercase mb-4">
              Est. 1993 — Jaipur
            </p>
            <p className="text-neutral-400 text-sm leading-relaxed">
              One of Rajasthan's most trusted automotive aftermarket spare parts distribution houses, 
              serving retailers and workshops since 1993.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-6 text-neutral-300">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
              { label: "Home", path: "/" },
              { label: "Our Brands", path: "/brands" },
              { label: "About Us", path: "/about" },
              { label: "Contact", path: "/contact" }].
              map((link) =>
              <li key={link.path}>
                  <Link
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-neutral-400 hover:text-white text-sm transition-colors">

                    {link.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-6 text-neutral-300">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#D32F2F] shrink-0" />
                <div className="text-sm text-neutral-400">
                  <a href="tel:+918824893533" className="hover:text-white block">+91 88248 93533</a>
                  <a href="tel:+919664206774" className="hover:text-white block">+91 96642 06774</a>
                  <a href="tel:+919414456359" className="hover:text-white block">+91 94144 56359</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#D32F2F] shrink-0" />
                <a href="mailto:rktraders.jp@gmail.com" className="text-sm text-neutral-400 hover:text-white">
                  rktraders.jp@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#D32F2F] shrink-0" />
                <span className="text-sm text-neutral-400">
                  1200/2, Behind Axis Bank, Barkat Nagar, Tonk Road, Jaipur 302015
                </span>
              </li>
            </ul>
          </div>

          {/* GST & Trust */}
          <div>
            <h4 className="font-heading font-bold text-sm uppercase tracking-wider mb-6 text-neutral-300">
              Trust Indicators
            </h4>
            <div className="space-y-4">
              <div
                data-testid="gst-display"
                className="border border-neutral-800 p-4">

                <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase block mb-1">
                  GSTIN
                </span>
                <span className="text-white font-mono text-sm font-medium">
                  08ABMPJ3350M1ZC
                </span>
              </div>
              <div className="border border-neutral-800 p-4">
                <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase block mb-1">
                  Established
                </span>
                <span className="text-white font-heading text-2xl font-bold">
                  1993
                </span>
              </div>
              <div className="border border-neutral-800 p-4">
                <span className="font-mono text-[10px] tracking-[0.2em] text-neutral-500 uppercase block mb-1">
                  Brands
                </span>
                <span className="text-white font-heading text-2xl font-bold">20+

                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-xs">
            &copy; {new Date().getFullYear()} R.K. Traders. All rights reserved.
          </p>
          <p className="text-neutral-600 text-xs font-mono uppercase tracking-wider">
            Automotive Spare Parts Distributor — Jaipur, Rajasthan
          </p>
        </div>
      </div>
    </footer>);

}